import http from '../http'
import { API_URL } from '../const'

export const getProduct = (pieceId: string) =>
  http.get(`${API_URL}/Taxonomy/Product/brickWithChildren/${pieceId}`)

export const getProcessedClass = () => http.get(`${API_URL}/Taxonomy/ProcessedIngredient/class`)

export const getSpecialIngredientClass = () =>
  http.get(`${API_URL}/Taxonomy/SpecialIngredient/class`)

export const getProcessedDropdowns = (level: string) =>
  http.get(`${API_URL}/Taxonomy/ProcessedIngredient/${level}`)

export const getSpecialIngredientDropdowns = (level: string) =>
  http.get(`${API_URL}/Taxonomy/SpecialIngredient/${level}`)

export const getProduceDropdowns = (level: string) =>
  http.get(`${API_URL}/Taxonomy/Produce/${level}`)

export const getProductDropdowns = (level: string) =>
  http.get(`${API_URL}/Taxonomy/Product/${level}`)

export const getSpecialDropdowns = (level: string) =>
  http.get(`${API_URL}/Taxonomy/SpecialIngredient/${level}`)
